import React from 'react';
import { Terminal, Trash2 } from 'lucide-react';
import { cn } from '../../../lib/utils';

const FunctionSidebar = ({
    udfs = [],
    previewFunction,
    setPreviewFunction,
    onManageFunctions,
    onRemoveFunction
}) => {
    return (
        <div className="flex flex-col h-full overflow-hidden">
            <div className="flex-1 overflow-y-auto px-2 space-y-0.5 custom-scrollbar">
                {udfs.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-12 text-center">
                        <div className="p-3 bg-gray-50 dark:bg-gray-900/50 rounded-lg mb-3">
                            <Terminal size={20} className="text-gray-300 dark:text-gray-700" />
                        </div>
                        <p className="text-[10px] font-medium text-gray-400 dark:text-gray-600 uppercase tracking-wider">
                            No functions
                        </p>
                    </div>
                ) : (
                    udfs.map(udf => (
                        <div
                            key={udf.id}
                            onClick={() => setPreviewFunction(udf)}
                            className={cn(
                                "flex items-center gap-2.5 px-2.5 py-2 rounded-lg transition-all cursor-pointer group relative",
                                previewFunction?.id === udf.id
                                    ? "bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300"
                                    : "hover:bg-gray-50 dark:hover:bg-gray-900/30 text-gray-700 dark:text-gray-300"
                            )}
                        >
                            <div className={cn(
                                "shrink-0 transition-colors",
                                previewFunction?.id === udf.id
                                    ? "text-emerald-600 dark:text-emerald-400"
                                    : "text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-400"
                            )}>
                                <Terminal size={14} />
                            </div>
                            <div className="flex-1 min-w-0 pr-6">
                                <h4 className={cn(
                                    "text-xs font-medium truncate",
                                    previewFunction?.id === udf.id
                                        ? "text-emerald-700 dark:text-emerald-300"
                                        : "text-gray-900 dark:text-gray-100"
                                )}>
                                    {udf.name}
                                </h4>
                                <p className="text-[9px] text-gray-500 dark:text-gray-500 mt-0.5 font-medium uppercase tracking-wide">
                                    {udf.source} function
                                </p>
                            </div>
                            {onRemoveFunction && (
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onRemoveFunction(udf.id);
                                    }}
                                    className={cn(
                                        "absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-300 hover:text-red-500 dark:text-gray-700 dark:hover:text-red-400 transition-all rounded opacity-0 group-hover:opacity-100",
                                        previewFunction?.id === udf.id && "opacity-100"
                                    )}
                                    title="Remove function"
                                >
                                    <Trash2 size={11} />
                                </button>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default FunctionSidebar;
